import { type RouteObject } from "react-router-dom";
import Repair from "@/pages/repair/edit-texts";
import loadRepairsData from "@/pages/repair/edit-texts/loader.ts";
import loadRepairRequests from "@/pages/repair/requests/loader.ts";
import RepairRequests from "@/pages/repair/requests";
import RepairRequestDetail from "@/pages/repair/requests/request-detail";
import loadRepairRequestDetail from "@/pages/repair/requests/request-detail/loader.ts";

export const repairRouteObjects: RouteObject[] = [
  {
    path: "repair",
    element: <RepairRequests />,
    loader: loadRepairRequests,
  },
  {
    path: "repair/:id",
    element: <RepairRequestDetail />,
    loader: loadRepairRequestDetail,
  },
  {
    path: "repair/edit-texts",
    element: <Repair />,
    loader: loadRepairsData,
  },
];
